import { useStaticQuery, graphql } from "gatsby"

export  const useStrapiVideosWebinarsPageData = () => {
    const { strapiVideopage } = useStaticQuery(graphql`
        query {
            strapiVideopage {
                title
                slug
                description
                keywords
                blocks {
                  strapi_component
                  title
                  videos {
                    slug
                    title
                    card_title
                    external_resource
                    displayOnVideosWebinarsPage
                    thumbnail {
                      alternativeText
                      localFile {
                        childImageSharp {
                          gatsbyImageData
                        }
                      }
                    }
                    body {
                      data {
                        childMarkdownRemark {
                          html
                          excerpt(format: HTML, pruneLength: 136)
                        }
                      }
                    }
                    video_url
                    date(formatString: "MMMM DD, YYYY")
                  }
                  series {
                    slug
                    title
                    card_title
                    author
                    resource_date(formatString: "YYYY")
                    thumbnail {
                      alternativeText
                      localFile {
                        childImageSharp {
                          gatsbyImageData
                        }
                      }
                    }
                    body {
                      data {
                        childMarkdownRemark {
                          html
                          excerpt(format: HTML, pruneLength: 136)
                        }
                      }
                    }
                    topics {
                      slug
                    }
                    videos_webinars_series {
                      title
                      slug
                    }
                  }
                }
                hero_image {
                  headline
                  description {
                    data {
                      childMarkdownRemark {
                        html
                      }
                    }
                  }
                  background_image {
                    alternativeText
                    localFile {
                      childImageSharp {
                        gatsbyImageData(aspectRatio: 1.77)
                      }
                    }
                  }
                }
              }
        }
    `)
    return { strapiVideopage }
}